// angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// internal
import { QSNotificationsActionComponent } from './action/action.component';
import { QSEmailNotificationComponent } from './email-notification/email-notification.component';
import { QSNotificationsCommandComponent } from './action/command/command.component';
import { QSNotificationsParametersComponent } from './action/parameters/parameters.component';
import { QSPushNotificationComponent } from './push-notification/push-notification.component';

export const QUICKSTART_ACTIONS_NOTIFICATIONS_ROUTES: Routes = [
  {
    path: 'notify/push/:command/:id', component: QSPushNotificationComponent
  }, {
    path: 'notify/email/:command/:id', component: QSEmailNotificationComponent
  }
];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/notifications.routes.ts